import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ userOrders }: RootState) => userOrders;

export const selectUserOrders = createSelector(
    selectRoot,
    ({ userOrders }) => userOrders,
);
